import baseURL from "../config/api";
import axios from "../config/axios";

export const post_Class = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}classes?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_EnrollmentClass = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}enrollmentClasses?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_ResendInvitationStudent = (enrollmentClassId: number) => {
    return axios({
        url: `${baseURL}enrollmentClasses/ResendInvitationForEnrollmentClass/${enrollmentClassId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false
    }).then(response => response.data);
}

export const put_enrollClass = (status: string, code: string, email:string, userId: number) => {
    return axios({
        url: `${baseURL}enrollmentClasses/UpdateEnrollmentClassStatusByEmail/${status},${email},${code},${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
    }).then(response => response.data);
}

export const delete_EnrollmentStudent = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}enrollmentClasses?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


export const getClassFromInvitationCode = (joinCode: string, userId: number) => {
    return getFetch(`classes/GetClassByJoinCode?joinCode=${joinCode}&userId=${userId}`)
}

export const getClassInvitationUserIdandEmail = (id: string, email: string) => {
    return getFetch(`enrollmentClasses/GetEnrollmentClassesByUserIdAndEmail/${id}/${email}`)
}

export const getClassFromInvitationCodeAndEmail = (joinCode: string, email: string) => {
    return getFetch(`classes/GetClassByJoinCodeAndEmail?joinCode=${joinCode}&email=${email}`)
}

export const getTeacherAllClasses = (userId: number) => {
    return getFetch(`classes/GetAllClassesOfTeacher/${userId}`)
}

export const getEnrolledClassesCourses = (userId: number) => {
    return getFetch(`classes/GetEnrolledClassesByStudentId/${userId}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}